export default __webpack_public_path__ + "static/media/avatar-s-14.ea440a6a.jpg";